"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubmitState;
(function (SubmitState) {
    SubmitState[SubmitState["ALLOWED"] = 0] = "ALLOWED";
    SubmitState["SUBMIT_REQUIRED_ERROR"] = "submit-required-error";
    SubmitState["SUBMIT_VALIDATION_ERROR"] = "submit-validation-error";
})(SubmitState = exports.SubmitState || (exports.SubmitState = {}));
